<template>
  <div class="row align-items-start">
    <div
      class="card-group col-lg-4 col-md-6 col-sm-12"
      v-for="(post, index) in posts"
      :key="index"
    >
      <div class="card">
        <NuxtLink
          :to="{
            name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
            params: {
              language: route.params.language,
              catergoriaId: post.tag_id,
              categoriaName: post.slugCategory,
              colunaId: post.id,
              colunaName: post.slug,
            },
          }"
        >
          <img
            :src="`${post.cover}`"
            :alt="post.title"
            width="394"
            height="333"
            loading="lazy"
          />
        </NuxtLink>
        <div class="card-body pb-5">
          <p
            class="card-text"
            v-for="description in post.meta_description"
            :key="description.language_id"
          >
            <NuxtLink :to="{
              name: 'language-colunas-catergoriaId-categoriaName',
              params: {
                language: route.params.language,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
              },
            }">
              <span
                class="category-title py-1 px-3 mt-1"
                v-if="
                  description.language_id === 1 &&
                  (route.params.language) === 'pt-br'
                "
                v-text="post.category"
              ></span>
              <span
                class="category-title py-1 px-3 mt-1"
                v-if="
                  description.language_id === 2 &&
                  (route.params.language) === 'en'
                "
                v-text="post.category"
              ></span>
            </NuxtLink>            
          </p>
          <NuxtLink
            :to="{
              name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
              params: {
                language: route.params.language,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
                colunaId: post.id,
                colunaName: post.slug,
              },
            }"
          >
            <div class="card-title">{{ post.title }}</div>
          </NuxtLink>
          <p
            class="card-text row"
            v-for="description in post.meta_description"
            :key="description.language_id"
          >
            <span
              v-if="
                description.language_id === 1 &&
                (route.params.language) === 'pt-br'
              "
              v-text="description.content"
            ></span>
            <span
              v-if="
                description.language_id === 2 &&
                (route.params.language) === 'en'
              "
              v-text="description.content"
            ></span>
          </p>

          <NuxtLink
            :to="{
              name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
              params: {
                language: route.params.language,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
                colunaId: post.id,
                colunaName: post.slug,
              },
            }"
            class="button--more"
          >
            {{ translate.moreBlog }}
            <font-awesome
              :icon="['fas', 'arrow-right']"
              size="sm"
              style="margin-left: 8px"
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";

defineProps(["posts"]);

const storeLocale = localeStore();
const route = useRoute();
const translate = computed(() =>
  (route.params.language) == "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);
</script>
<style scoped>
.card-group {
  margin-top: 25px;
}
.card-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  margin-bottom: 5px;
  margin-top: 10px;
}

.card-text {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 5px !important;
}

.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.small svg {
  margin-right: 5px;
}

.card img {
  width: 100%;
  height: 333px;
  object-fit: cover;
}

.banner-promotion img {
  width: 100%;
  height: 333px;
  cursor: pointer;
  object-fit: cover;
}

.card-body {
  background-color: #f6f8fb;
  padding: 16px 0px;
}

.category-title {
  background-color: black;
  border-radius: 20px;
  text-align: center;
  max-width: 9rem;
  color: #fff;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
}

@media screen and (max-width: 991px) {
  .card-group:nth-child(3) {
    display: none;
  }
}
</style>
